<template>
  <div>
    <el-dialog
      v-model="drawer"
      width="900px"
      style="height: 760px; padding: 0; border-radius: 8px"
      :close-on-click-modal="false"
      :show-close="false"
      @click="postCodeChange"
    >
      <template #header="{ close }">
        <div class="my-header">
          <div class="my-header-title">申请主体</div>
          <div
            class="applicant-state"
            :class="
              applicant.flowState == 2
                ? 'success-state'
                : applicant.flowState == 3
                ? 'error-state'
                : applicant.flowState == 0 ||
                  applicant.flowState == 1 ||
                  applicant.flowState == 4
                ? 'warn-state'
                : ''
            "
          >
            {{ getApplicantStateName(applicant.flowState) }}
          </div>
          <div style="flex: 1"></div>
          <el-icon
            color="#9EA0A5"
            @click="close"
            style="cursor: pointer; padding: 5px"
            ><Close
          /></el-icon>
        </div>
      </template>
      <div class="set-box">
        <el-scrollbar class="set-content" height="660px">
          <ApplicatReview
            :applicant="applicant"
            v-if="
              applicant.flowState == 1 ||
              applicant.flowState == 2 ||
              applicant.flowState == 4
            "
          >
          </ApplicatReview>
          <Applicat
            ref="applicat"
            v-else
            :applicant="applicant"
            :blacklistState="blacklistState"
            :millList="millList"
            :millListChildren="millListChildren"
            :addressCodes="addressCodes"
            @getQueryBlackList="getQueryBlackList"
          >
          </Applicat>
          <Contact
            ref="contact"
            :applicant="applicant"
            :millList="millList"
            :millListChildren="millListChildren"
            @applicantContactChange="applicantContactChange"
            :addressCodes="addressCodes"
          ></Contact>
          <ApplicatLog
            v-if="applicantIde"
            :auditRecordVoList="applicant.auditRecordVoList"
          ></ApplicatLog>
        </el-scrollbar>
        <div class="set-btn">
          <Query
            :applicant="applicant"
            @onHoldApplicat="onHoldApplicat"
            @onSaveApplicat="onSaveApplicat"
            @handleClose="handleClose"
          ></Query>
        </div>
        <!-- 申请人黑名单校验 -->
        <Blacklist ref="blacklist" :blacklistState="blacklistState"></Blacklist>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  applicantAdd,
  applicantUpdate,
  applicantDetail,
  getQueryBlackList,
  getBrandRegions
} from "@/server/applicant";
import _validate from "@/framework/common/qds_validate";
import _tools from "@/components/common/tools";
import Applicat from "../plugin/applicat";
import ApplicatReview from "../plugin/applicatReview";
import Contact from "../plugin/contact";
import ApplicatLog from "../plugin/applicatLog";
import Blacklist from "../plugin/blacklist";
import Query from "../plugin/query";
export default {
  components: {
    Applicat,
    ApplicatReview,
    Contact,
    ApplicatLog,
    Blacklist,
    Query,
  },
  data() {
    return {
      applicant: {
        applicantType: 0, // 申请人类型 0个人持有，1公司持有
        bookType: 1, // 书式类型,1表示中国,2表示海外,3表示台湾,4表示香港,5表示澳门
        subjectType: 1, // 主体资格类型，1中文，0英文
        applicantDetailType: 0, // 资质类型0个人，1公司，2个体工商户
        applicantIdCardImg: "", // 身份证照片信息
        idCardEnglishPic: "", // 身份证明英文
        applicantQualification: "", // 主体资格证明
        licenseEnglishPic: "", // 主体资格证明英文
        applicantName: "", // 申请人名称
        applicantEnglishName: "", // 申请人英文名称
        country: "", // 国家或地区
        creditCode: "", // 统一社会信用代码
        idCard: "", // 税号/身份证号
        certificatesType: 1, // 证件类型,1:身份证, 2:护照, 3 其他,4:营业执照，5：事业单位法人证书，6：社会团体法人登记证书，7：民办非企业单位登记证书；8-基金会法人登记证书，9-律师事务所执业许可证
        applicantAddress: "", // 申请人地址
        applicantEnglishAddress: "", // 申请人地址英文
        code: "", // 邮政编码
        contactInchargeName: "", // 负责人姓名
        contactInchargeRole: "", // 负责人职务
        applicantProxy: "", // 客户委托书信息
        simpleUrl: "", // 委托书生成结果
        applicantProxyChapter: "", // 委托书公章
        applicantProxyStatement: "", // 委托书复用声明
        flowState: 0, // 申请主体状态
        tickLocation: "", // 委托书模板定位
        citys: [], // 区域code码
        limitStartTime: "", // 有效期 开始日期
        limitEndTime: "", // 有效期 结束日期
        limitType: 1, // 是否长期有效 1 长期有效，0 短期有效
        domesticReceiverEmail: "", // 申请人联系邮箱
        prov: "", // 申请人省
        city: "", // 申请人市
        area: "", // 申请人区
        provinceName: "", // 申请人省名称
        cityName: "", // 申请人市名称
        areaName: "", // 申请人区名称
        extCode: "", //后续文件接收信息 联系人邮编
        extName: "", //后续文件接收信息 联系人姓名
        extTel: "", //后续文件接收信息 联系人电话
        domesticProv: "", // "国内接收人省
        domesticCity: "", // 国内接收人市
        domesticArea: "", // 国内接收人区
        domesticProvinceName: "", // 国内接收人省名称
        domesticCityName: "", // 国内接收人市名称
        domesticAreaName: "", // 国内接收人区名称
        useApplicantProxy: 1,
        personalSubjectType: 1, // 个人主体资格证明文件类型:1-个体工商户营业执照，2-农村土地承包经营合同复印件，3-其他
      },
      applicantCopy: {
        applicantType: 0, // 申请人类型 0个人持有，1公司持有
        bookType: 1, // 书式类型,1表示中国,2表示海外,3表示台湾,4表示香港,5表示澳门
        subjectType: 1, // 主体资格类型，1中文，0英文
        applicantDetailType: 0, // 资质类型0个人，1公司，2个体工商户
        applicantIdCardImg: "", // 身份证照片信息
        idCardEnglishPic: "", // 身份证明英文
        applicantQualification: "", // 主体资格证明
        licenseEnglishPic: "", // 主体资格证明英文
        applicantName: "", // 申请人名称
        applicantEnglishName: "", // 申请人英文名称
        country: "", // 国家或地区
        creditCode: "", // 统一社会信用代码
        idCard: "", // 税号/身份证号
        certificatesType: 1, // 证件类型,1:身份证, 2:护照, 3 其他,4:营业执照，5：事业单位法人证书，6：社会团体法人登记证书，7：民办非企业单位登记证书；8-基金会法人登记证书，9-律师事务所执业许可证
        applicantAddress: "", // 申请人地址
        applicantEnglishAddress: "", // 申请人地址英文
        code: "", // 邮政编码
        contactInchargeName: "", // 负责人姓名
        contactInchargeRole: "", // 负责人职务
        applicantProxy: "", // 客户委托书信息
        simpleUrl: "", // 委托书生成结果
        applicantProxyChapter: "", // 委托书公章
        applicantProxyStatement: "", // 委托书复用声明
        flowState: 0, // 申请主体状态
        tickLocation: "", // 委托书模板定位
        citys: [], // 区域code码
        limitStartTime: "", // 有效期 开始日期
        limitEndTime: "", // 有效期 结束日期
        limitType: 0, // 是否长期有效 1 长期有效，0 短期有效
        domesticReceiverEmail: "", // 申请人联系邮箱
        prov: "", // 申请人省
        city: "", // 申请人市
        area: "", // 申请人区
        provinceName: "", // 申请人省名称
        cityName: "", // 申请人市名称
        areaName: "", // 申请人区名称
        extAddress: "", //后续文件接收信息 联系人地址
        extCode: "", //后续文件接收信息 联系人邮编
        extName: "", //后续文件接收信息 联系人姓名
        extTel: "", //后续文件接收信息 联系人电话
        domesticProv: "", // "国内接收人省
        domesticCity: "", // 国内接收人市
        domesticArea: "", // 国内接收人区
        domesticProvinceName: "", // 国内接收人省名称
        domesticCityName: "", // 国内接收人市名称
        domesticAreaName: "", // 国内接收人区名称
        useApplicantProxy: 1,
        personalSubjectType: 1, // 个人主体资格证明文件类型:1-个体工商户营业执照，2-农村土地承包经营合同复印件，3-其他
      },
      applicantContactsList: [],
      applicantIde: "",
      blacklistState: true, // 是否通过黑名单
      drawer: false,
      copyApplicant: 0,
      millList: [],
      millListCopy: [],
      millListChildren: [],
      addressCodes: {
        addressApplicant: [],
        addressDomestic: [],
      },
    };
  },

  mounted() {},

  methods: {
    // 初始化数据
    init(applicantIde, copy) {
      let self = this;
      self.getBrandRegions();
      self.applicantIde = applicantIde;
      self.copyApplicant = copy;
      self.applicantContactsList = [];
      if (!_validate.checkEmpty(self.applicantIde)) {
        self.applicantDetail();
      } else {
        self.applicant = { ...self.applicantCopy };
        this.drawer = true;
        if (![1, 2, 4].includes(self.applicant.flowState)) {
          this.$nextTick(() => {
            this.$refs.applicat.init();
          });
        }
      }
    },
    // 获取省市县数据
    async getBrandRegions() {
      let res = await getBrandRegions({});
      this.millListCopy = res;
      let list1 = [];
      let list2 = [];
      let list3 = [];
      if (!_validate.checkListEmpty(res)) {
        res.forEach((item) => {
          if (item.level == 1) {
            item.children = [];
            list1.push(item);
          } else if (item.level == 2) {
            item.children = [];
            list2.push(item);
          } else if (item.level == 3) {
            list3.push(item);
          }
        });
        this.filterData(list1, list2, list3);
      }
    },
    // 过滤数据
    filterData(list1, list2, list3) {
      let self = this;
      list2.forEach((item) => {
        list3.forEach((val) => {
          if (val.parent == item.id) {
            item.children.push(val);
          }
        });
      });
      for (let i = 0; i < list2.length; i++) {
        if (_validate.checkListEmpty(list2[i].children)) {
          delete list2[i].children;
        }
      }
      list1.forEach((data) => {
        list2.forEach((obj) => {
          if (obj.parent == data.id) {
            data.children.push(obj);
          }
        });
      });
      self.millListChildren = list1;
      self.millList = _tools.pinyinSort(list1, "name");
    },
    // 申请主体状态
    getApplicantStateName(state) {
      switch (state) {
        case 0:
          return "待提交";
        case 1:
          return "待审核";
        case 2:
          return "审核通过";
        case 3:
          return "审核不通过";
        case 4:
          return "待审核";
        case 5:
          return "暂存";
        default:
          break;
      }
    },
    // 申请主体管理详情
    async applicantDetail() {
      let self = this;
      let res = {};
      if (self.applicantIde.length > 10) {
        res = await applicantDetail({ applicantIde: self.applicantIde });
      } else {
        res = await applicantDetail({ applicantId: self.applicantIde });
      }
      self.applicant = res;
      // 有效期类型处理
      self.applicant.limitType = false;
      // 申请人地址处理
      if (res.city == 0) {
        self.addressCodes.addressApplicant = [res.prov];
      } else if (res.area == 0) {
        self.addressCodes.addressApplicant = [res.prov, res.city];
      } else {
        self.addressCodes.addressApplicant = [res.prov, res.city, res.area];
      }
      if (res.domesticCity == 0) {
        self.addressCodes.addressDomestic = [
          res.domesticProv,
        ];
      } else if (res.domesticArea == 0) {
        self.addressCodes.addressDomestic = [
          res.domesticProv,
          res.domesticCity,
        ];
      } else {
        self.addressCodes.addressDomestic = [
          res.domesticProv,
          res.domesticCity,
          res.domesticArea,
        ];
      }
      // 区域信息处理
      self.applicant.citys = [];
      // 后续文件接收人信息处理
      self.applicant.domesticReceiverEmail =
        self.applicant.domesticReceiverEmail || "";
      self.applicant.extAddress = self.applicant.extAddress || "";
      self.applicant.extCode = self.applicant.extCode || "";
      self.applicant.extName = self.applicant.extName || "";
      self.applicant.extTel = self.applicant.extTel || "";
      // 黑名单信息处理
      self.applicantContactsList = res.applicantContactsList;
      if (res.inBlackList == 1) {
        self.$refs.blacklist.init(res.applicantName);
        self.blacklistState = false;
        self.blackState;
      } else {
        self.blacklistState = true;
      }
      if (self.copyApplicant) {
        self.applicant.applicantId = "";
        self.applicant.applicantIde = "";
        self.applicant.flowState = 0;
        self.applicantIde = "";
        self.copyApplicant = 0;
      }
      this.drawer = true;
      if (![1, 2, 4].includes(self.applicant.flowState)) {
        this.$nextTick(() => {
          this.$refs.applicat.init();
        });
      }
    },
    // 暂存申请人信息
    onHoldApplicat() {
      let self = this;
      if (self.applicant.applicantType == 0) {
        // 申请人类型为个人
        if (self.applicant.bookType == 1) {
          // 中国
          self.onSaveHoldApplicat();
          return
        } else if (self.applicant.bookType == 2) {
          // 海外
          if (_validate.checkEmpty(self.applicant.country)) {
            self.onSaveHoldApplicat();
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishName)) {
            self.onSaveHoldApplicat();
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishAddress)) {
            self.onSaveHoldApplicat();
            return;
          }
        } else if (
          self.applicant.bookType == 3 ||
          self.applicant.bookType == 4 ||
          self.applicant.bookType == 5
        ) {
          // 台湾、香港、澳门
          if (_validate.checkEmpty(self.applicant.subjectType)) {
            self.onSaveHoldApplicat();
            return;
          }
        }
        if (_validate.checkEmpty(self.applicant.applicantIdCardImg)) {
          self.onSaveHoldApplicat();
          return;
        }
        if (
          self.applicant.subjectType == 0 &&
          _validate.checkEmpty(self.applicant.idCardEnglishPic)
        ) {
          self.onSaveHoldApplicat();
          return;
        }
        if (
          self.applicant.bookType == 1 &&
          _validate.checkEmpty(self.applicant.applicantQualification)
        ) {
          self.onSaveHoldApplicat();
          return;
        }
        if (_validate.checkEmpty(self.applicant.certificatesType)) {
          self.onSaveHoldApplicat();
          return;
        }
        if (_validate.checkEmpty(self.applicant.idCard)) {
          self.onSaveHoldApplicat();
          return;
        }
      } else if (self.applicant.applicantType == 1) {
        // 申请人主体为企业
        if (self.applicant.bookType == 1) {
          // 中国
          if (_validate.checkEmpty(self.applicant.creditCode)) {
            self.onSaveHoldApplicat();
            return;
          }
          if (
            self.applicant.creditCode.length != 15 &&
            self.applicant.creditCode.length != 18
          ) {
            self.onSaveHoldApplicat();
            return;
          }
        } else if (self.applicant.bookType == 2) {
          // 海外
          if (_validate.checkEmpty(self.applicant.country)) {
            self.onSaveHoldApplicat();
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishName)) {
            self.onSaveHoldApplicat();
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishAddress)) {
            self.onSaveHoldApplicat();
            return;
          }
        } else if (
          self.applicant.bookType == 3 ||
          self.applicant.bookType == 4 ||
          self.applicant.bookType == 5
        ) {
          // 台湾、香港、澳门
          if (_validate.checkEmpty(self.applicant.subjectType)) {
            self.onSaveHoldApplicat();
            return;
          }
        }
        if (_validate.checkEmpty(self.applicant.applicantQualification)) {
          self.onSaveHoldApplicat();
          return;
        }
        if (
          _validate.checkEmpty(self.applicant.licenseEnglishPic) &&
          self.applicant.subjectType == 0
        ) {
          self.onSaveHoldApplicat();
          return;
        }
      }
      // 申请人信息共有字段限制
      if (_validate.checkEmpty(self.applicant.applicantName)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantAddress)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.code)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.domesticReceiverEmail)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.extAddress)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.extCode)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.extName)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.extTel)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantProxy)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantProxyStatement)) {
        self.onSaveHoldApplicat();
        return;
      }
      if (!self.blacklistState) {
        self.$message.warning("当前申请主体已命中黑名单，请修改后进行保存！");
        return;
      }
      // 申请人信息完整，校验后保存
      this.applicatCheck();
    },
    onSaveHoldApplicat() {
      let self = this;
      if (_validate.checkEmpty(self.applicantIde)) {
        self.applicantAdd(1);
      } else {
        self.applicantUpdate(1);
      }
    },
    // 保存申请人信息
    onSaveApplicat() {
      this.$refs.contact.contactUpdate();
      if (!this.applicantIde || this.applicant.flowState == 5) {
        this.onHoldApplicat();
      } else {
        this.applicatCheck();
      }
    },
    // 申请人信息校验
    applicatCheck() {
      let self = this;
      if (self.applicant.applicantType == 0) {
        // 申请人类型为个人
        if (self.applicant.bookType == 1) {
          // 中国
          if (_validate.checkEmpty(self.applicant.personalSubjectType)) {
            self.$message.warning("请选择主体资格证明文件类型！");
            return;
          }
          if (
            self.applicant.certificatesType == 1 &&
            self.applicant.idCard.length != 18
          ) {
            self.$message.warning("请填写正确的18位证件号码");
            return;
          }
          if (
            self.applicant.personalSubjectType === 0 &&
            _validate.checkEmpty(self.applicant.creditCode)
          ) {
            self.$message.warning("社会信用代码不能为空！");
            return;
          }
          if (self.addressCodes.addressApplicant.length == 0) {
            self.$message.warning("请选择申请人地址！");
            return;
          }
        } else if (self.applicant.bookType == 2) {
          // 海外
          if (_validate.checkEmpty(self.applicant.country)) {
            self.$message.warning("国家或地区不能为空！");
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishName)) {
            self.$message.warning("申请人名称英文不能为空！");
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishAddress)) {
            self.$message.warning("申请人地址英文不能为空！");
            return;
          }
        } else if (
          self.applicant.bookType == 3 ||
          self.applicant.bookType == 4 ||
          self.applicant.bookType == 5
        ) {
          // 台湾、香港、澳门
          if (_validate.checkEmpty(self.applicant.subjectType)) {
            self.$message.warning("材料是否英文不能为空！");
            return;
          }
        }
        if (_validate.checkEmpty(self.applicant.applicantIdCardImg)) {
          self.$message.warning("身份证不能为空！");
          return;
        }
        if (
          self.applicant.subjectType == 0 &&
          _validate.checkEmpty(self.applicant.idCardEnglishPic)
        ) {
          self.$message.warning("身份证英文不能为空！");
          return;
        }
        if (
          self.applicant.bookType == 1 &&
          _validate.checkEmpty(self.applicant.applicantQualification)
        ) {
          self.$message.warning("营业执照不能为空！");
          return;
        }
        // if (
        //   self.applicant.bookType == 1 &&
        //   self.applicant.applicantDetailType == 2 &&
        //   _validate.checkEmpty(self.applicant.creditCode)
        // ) {
        //   self.$message.warning("统一社会信用代码不能为空！");
        //   return;
        // }
        // if (
        //   self.applicant.bookType == 1 &&
        //   self.applicant.applicantDetailType == 2 &&
        //   self.applicant.creditCode.length != 15 &&
        //   self.applicant.creditCode.length != 18
        // ) {
        //   self.$message.warning("请填写正确的15或18位统一社会信用代码");
        //   return;
        // }
        if (_validate.checkEmpty(self.applicant.certificatesType)) {
          self.$message.warning("证件类型不能为空！");
          return;
        }
        if (_validate.checkEmpty(self.applicant.idCard)) {
          self.$message.warning("证件号码不能为空！");
          return;
        }
      } else if (self.applicant.applicantType == 1) {
        // 申请人主体为企业
        if (self.applicant.bookType == 1) {
          // 中国
          if (_validate.checkEmpty(self.applicant.creditCode)) {
            self.$message.warning("统一社会信用代码不能为空！");
            return;
          }
          if (
            self.applicant.creditCode.length != 15 &&
            self.applicant.creditCode.length != 18
          ) {
            self.$message.warning("请填写正确的15或18位统一社会信用代码");
            return;
          }
          if (self.addressCodes.addressApplicant.length == 0) {
            self.$message.warning("请选择申请人地址！");
            return;
          }
        } else if (self.applicant.bookType == 2) {
          // 海外
          if (_validate.checkEmpty(self.applicant.country)) {
            self.$message.warning("国家或地区不能为空！");
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishName)) {
            self.$message.warning("申请人名称英文不能为空！");
            return;
          }
          if (_validate.checkEmpty(self.applicant.applicantEnglishAddress)) {
            self.$message.warning("申请人地址英文不能为空！");
            return;
          }
        } else if (
          self.applicant.bookType == 3 ||
          self.applicant.bookType == 4 ||
          self.applicant.bookType == 5
        ) {
          // 台湾、香港、澳门
          if (_validate.checkEmpty(self.applicant.subjectType)) {
            self.$message.warning("材料是否英文不能为空！");
            return;
          }
        }
        if (_validate.checkEmpty(self.applicant.applicantQualification)) {
          self.$message.warning("营业执照不能为空！");
          return;
        }
        if (
          _validate.checkEmpty(self.applicant.licenseEnglishPic) &&
          self.applicant.subjectType == 0
        ) {
          self.$message.warning("营业执照英文不能为空！");
          return;
        }
      }
      // 申请人信息共有字段限制
      if (_validate.checkEmpty(self.applicant.applicantName)) {
        self.$message.warning("申请人名称不能为空！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantAddress)) {
        self.$message.warning("申请人地址不能为空！");
        return;
      }
      if (
        self.applicant.bookType == 1 &&
        !_validate.checkMill(self.applicant.applicantAddress)
      ) {
        self.$message.warning("申请人地址请填写完整的省市！");
        return;
      }
      if (
        this.applicant.bookType == 3 &&
        this.applicant.applicantAddress.indexOf("台湾") < 0
      ) {
        self.$message.warning("申请人地址请填写完整的省市！");
        return;
      }
      if (
        this.applicant.bookType == 4 &&
        this.applicant.applicantAddress.indexOf("香港") < 0
      ) {
        self.$message.warning("申请人地址请填写完整的省市！");
        return;
      }
      if (
        this.applicant.bookType == 5 &&
        this.applicant.applicantAddress.indexOf("澳门") < 0
      ) {
        self.$message.warning("申请人地址请填写完整的省市！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.code)) {
        self.$message.warning("邮政编码不能为空！");
        return;
      }
      if (self.applicant.code.length != 6) {
        self.$message.warning("邮政编码格式有误，请重新输入！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantProxy)) {
        self.$message.warning("委托书不能为空！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.applicantProxyStatement)) {
        self.$message.warning("委托书复用法律申明不能为空！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.extName)) {
        self.$message.warning("后续文件接收联系人姓名不能为空！");
        return;
      }
      if (self.addressCodes.addressDomestic.length == 0) {
        self.$message.warning("请选择后续文件接收联系人地址！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.extAddress)) {
        self.$message.warning("后续文件接收联系人地址不能为空！");
        return;
      }
      if (
        self.applicant.bookType == 1 &&
        !_validate.checkMill(self.applicant.extAddress)
      ) {
        self.$message.warning("后续文件接收联系人地址请填写完整的省市！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.domesticReceiverEmail)) {
        self.$message.warning("后续文件接收联系人邮箱不能为空！");
        return;
      }
      if (
        !_validate.checkEmpty(self.applicant.domesticReceiverEmail) &&
        _validate.checkMail(self.applicant.domesticReceiverEmail)
      ) {
        self.$message.warning("后续文件接收联系人邮箱格式有误，请重新输入！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.extTel)) {
        self.$message.warning("后续文件接收联系人电话不能为空！");
        return;
      }
      if (
        self.applicant.extTel.length != 11 ||
        self.applicant.extTel.slice(0, 1) != 1
      ) {
        self.$message.warning("后续文件接收联系人电话格式有误，请重新输入！");
        return;
      }
      if (_validate.checkEmpty(self.applicant.extCode)) {
        self.$message.warning("后续文件接收联系人邮编不能为空！");
        return;
      }
      if (self.applicant.extCode.length != 6) {
        self.$message.warning("后续文件接收联系人邮编格式有误，请重新输入！");
        return;
      }
      if (!self.blacklistState) {
        self.$message.warning("当前申请主体已命中黑名单，请修改后进行保存！");
        return;
      }
      if (_validate.checkEmpty(self.applicantIde)) {
        self.applicantAdd(0);
      } else {
        self.applicantUpdate(0);
      }
    },
    // 申请主体管理新增
    async applicantAdd(staging) {
      let self = this;
      if (self.addressCodes.addressApplicant.length > 0) {
        if (self.addressCodes.addressApplicant.length == 3) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = self.addressCodes.addressApplicant[1];
          self.applicant.area = self.addressCodes.addressApplicant[2];
        } else if (self.addressCodes.addressApplicant.length == 2) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = self.addressCodes.addressApplicant[1];
          self.applicant.area = 0;
        } else if (self.addressCodes.addressApplicant.length == 1) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = 0;
          self.applicant.area = 0;
        }
        self.millListCopy.forEach((item) => {
          if (self.applicant.prov == item.id) {
            self.applicant.provinceName = item.name;
          }
          if (self.applicant.city == 0) {
            self.applicant.cityName = "";
          } else if (self.applicant.city == item.id) {
            self.applicant.cityName = item.name;
          }
          if (self.applicant.area == 0) {
            self.applicant.areaName = "";
          } else if (self.applicant.area == item.id) {
            self.applicant.areaName = item.name;
          }
        });
      }
      if (self.addressCodes.addressDomestic.length > 0) {
        if (self.addressCodes.addressDomestic.length == 3) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = self.addressCodes.addressDomestic[1];
          self.applicant.domesticArea = self.addressCodes.addressDomestic[2];
        } else if (self.addressCodes.addressDomestic.length == 2) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = self.addressCodes.addressDomestic[1];
          self.applicant.domesticArea = 0;
        } else if (self.addressCodes.addressDomestic.length == 1) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = 0;
          self.applicant.domesticArea = 0;
        }
        self.millListCopy.forEach((item) => {
          if (self.applicant.domesticProv == item.id) {
            self.applicant.domesticProvinceName = item.name;
          }
          if (self.applicant.domesticCity == 0) {
            self.applicant.domesticCityName = "";
          } else if (self.applicant.domesticCity == item.id) {
            self.applicant.domesticCityName = item.name;
          }
          if (self.applicant.domesticArea == 0) {
            self.applicant.domesticAreaName = "";
          } else if (self.applicant.domesticArea == item.id) {
            self.applicant.domesticAreaName = item.name;
          }
        });
      }
      self.applicant.useApplicantProxy = 1;
      let params = {
        ...self.applicant,
        staging: staging,
      };
      let res = await applicantAdd(params);
      if (res) {
        self.applicantIde = res.applicantId;
        self.$message.success("操作成功！");
        self.onSave();
      }
    },
    // 申请主体管理编辑
    async applicantUpdate(staging) {
      let self = this;
      if (self.addressCodes.addressApplicant.length > 0) {
        if (self.addressCodes.addressApplicant.length == 3) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = self.addressCodes.addressApplicant[1];
          self.applicant.area = self.addressCodes.addressApplicant[2];
        } else if (self.addressCodes.addressApplicant.length == 2) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = self.addressCodes.addressApplicant[1];
          self.applicant.area = 0;
        } else if (self.addressCodes.addressApplicant.length == 1) {
          self.applicant.prov = self.addressCodes.addressApplicant[0];
          self.applicant.city = 0;
          self.applicant.area = 0;
        }
        self.millListCopy.forEach((item) => {
          if (self.applicant.prov == item.id) {
            self.applicant.provinceName = item.name;
          }
          if (self.applicant.city == 0) {
            self.applicant.cityName = "";
          } else if (self.applicant.city == item.id) {
            self.applicant.cityName = item.name;
          }
          if (self.applicant.area == 0) {
            self.applicant.areaName = "";
          } else if (self.applicant.area == item.id) {
            self.applicant.areaName = item.name;
          }
        });
      }
      if (self.addressCodes.addressDomestic.length > 0) {
        if (self.addressCodes.addressDomestic.length == 3) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = self.addressCodes.addressDomestic[1];
          self.applicant.domesticArea = self.addressCodes.addressDomestic[2];
        } else if (self.addressCodes.addressDomestic.length == 2) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = self.addressCodes.addressDomestic[1];
          self.applicant.domesticArea = 0;
        } else if (self.addressCodes.addressDomestic.length == 1) {
          self.applicant.domesticProv = self.addressCodes.addressDomestic[0];
          self.applicant.domesticCity = 0;
          self.applicant.domesticArea = 0;
        }
        self.millListCopy.forEach((item) => {
          if (self.applicant.domesticProv == item.id) {
            self.applicant.domesticProvinceName = item.name;
          }
          if (self.applicant.domesticCity == 0) {
            self.applicant.domesticCityName = "";
          } else if (self.applicant.domesticCity == item.id) {
            self.applicant.domesticCityName = item.name;
          }
          if (self.applicant.domesticArea == 0) {
            self.applicant.domesticAreaName = "";
          } else if (self.applicant.domesticArea == item.id) {
            self.applicant.domesticAreaName = item.name;
          }
        });
      }
      self.applicant.useApplicantProxy = 1;
      let params = {
        ...self.applicant,
        staging: staging,
        applicantIde: self.applicantIde,
      };
      await applicantUpdate(params);
      self.$message.success("操作成功！");
      self.onSave();
      // self.onReset();
    },
    // 编辑申请主体监测
    applicantContactChange(contact) {
      this.applicant.domesticReceiverEmail = contact.domesticReceiverEmail;
      this.applicant.extAddress = contact.extAddress;
      this.applicant.extCode = contact.extCode;
      this.applicant.extName = contact.extName;
      this.applicant.extTel = contact.extTel;
    },
    // 黑名单校验
    async getQueryBlackList() {
      let self = this;
      // 1 黑名单      0 白
      let params = {
        applicantName: self.applicant.applicantName,
        identityNo: self.applicant.creditCode,
        ownerType: self.applicant.applicantType,
        idCard: self.applicant.idCard,
      };
      let res = await getQueryBlackList(params);
      if (res == 1) {
        self.blacklistState = false;
      } else {
        self.blacklistState = true;
      }
    },
    // 重置数据
    onReset() {
      let self = this;
      if (_validate.checkEmpty(self.applicantIde)) {
        self.applicant = {
          applicantType: 0, // 申请人类型 0个人持有，1公司持有
          bookType: 1, // 书式类型,1表示中国,2表示海外,3表示台湾,4表示香港,5表示澳门
          subjectType: 1, // 主体资格类型，1中文，0英文
          applicantDetailType: 0, // 资质类型0个人，1公司，2个体工商户
          applicantIdCardImg: "", // 身份证照片信息
          idCardEnglishPic: "", // 身份证明英文
          applicantQualification: "", // 主体资格证明
          licenseEnglishPic: "", // 主体资格证明英文
          applicantName: "", // 申请人名称
          applicantEnglishName: "", // 申请人英文名称
          country: "", // 国家或地区
          creditCode: "", // 统一社会信用代码
          idCard: "", // 税号/身份证号
          certificatesType: 1, // 证件类型,1:身份证, 2:护照, 3 其他
          applicantAddress: "", // 申请人地址
          applicantEnglishAddress: "", // 申请人地址英文
          domesticReceiverEmail: "", // 后续文件接收信息 联系人邮箱
          prov: "", // 申请人省
          city: "", // 申请人市
          area: "", // 申请人区
          provinceName: "", // 申请人省名称
          cityName: "", // 申请人市名称
          areaName: "", // 申请人区名称
          extAddress: "", //后续文件接收信息 联系人地址
          extCode: "", //后续文件接收信息 联系人邮编
          extName: "", //后续文件接收信息 联系人姓名
          extTel: "", //后续文件接收信息 联系人电话
          code: "", // 邮政编码
          contactInchargeName: "", // 负责人姓名
          contactInchargeRole: "", // 负责人职务
          applicantProxy: "", // 客户委托书信息
          simpleUrl: "", // 委托书生成结果
          applicantProxyChapter: "", // 委托书公章
          applicantProxyStatement: "", // 委托书复用声明
          flowState: 0, // 申请主体状态
          domesticProv: "", // "国内接收人省
          domesticCity: "", // 国内接收人市
          domesticArea: "", // 国内接收人区
          domesticProvinceName: "", // 国内接收人省名称
          domesticCityName: "", // 国内接收人市名称
          domesticAreaName: "", // 国内接收人区名称
          useApplicantProxy: 1,
          personalSubjectType: 0, // 个人主体资格证明文件类型:1-个体工商户营业执照，2-农村土地承包经营合同复印件，3-其他
        };
        self.addressCodes = {
          addressApplicant: [],
          addressDomestic: [],
        };
      }
    },
    // 关闭弹窗
    handleClose() {
      this.drawer = false;
    },
    // 保存后续更新操作
    onSave() {
      let self = this;
      if (self.applicantIde) {
        this.$emit(
          "onSaveApplicant",
          self.applicant.applicantId,
          self.applicant.flowState,
          self.applicant.applicantName
        );
      } else {
        this.$emit("onSaveApplicant");
      }
      this.handleClose();
    },
    postCodeChange() {
      if (
        this.applicant.flowState != 1 &&
        this.applicant.flowState != 2 &&
        this.applicant.flowState != 4
      ) {
        this.$refs.applicat.codeStateChange(false);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.my-header {
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  padding: 14px 15px 14px 20px;
  box-shadow: 0px 0px 4px 0px rgba(12, 27, 50, 0.1);

  .my-header-title {
    color: #111111;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 2px;
  }

  .applicant-state {
    padding: 2px 6px;
    font-size: 12px;
    color: #666666;
    background: #efefef;
    border-radius: 4px;
    margin-left: 8px;

    &.success-state {
      color: #22cc88;
      background: #e1f8f0;
    }

    &.error-state {
      color: #ff6655;
      background: #ffe6e5;
    }

    &.warn-state {
      background: #fff7e5;
      color: #ffb000;
    }
  }
}
.set-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  margin: 0;
  flex-direction: column;

  .set-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .set-btn {
    height: 50px;
  }
}

&:deep(.el-dialog__body) {
  padding: 0px !important;
  overflow: hidden;
}

&:deep(.el-dialog__header) {
  padding: 0;
  margin: 0;
}

&:deep(.el-dialog) {
  --el-dialog-margin-top: 7vh;
}
</style>
